module.exports = __webpack_public_path__ + "img/contentImgHover4.d0717c6.webp";